import { Order } from './order';

export interface OrdersResponse {
  count: number;
  orders: Order[];
}
